import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getAuthLog(params) {
  return request({
    url: '/auditTrail/auth',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
  });
}
